module.exports = __webpack_public_path__ + "static/media/sportplan-videos.e5d6ef18.md";